/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import SubscriptionsSubscription from './SubscriptionsSubscription';

/**
 * The SubscriptionsBody model module.
 * @module model/SubscriptionsBody
 * @version v0.3
 */
export default class SubscriptionsBody {
  /**
   * Constructs a new <code>SubscriptionsBody</code>.
   * @alias module:model/SubscriptionsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SubscriptionsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SubscriptionsBody} obj Optional instance to populate.
   * @return {module:model/SubscriptionsBody} The populated <code>SubscriptionsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SubscriptionsBody();
      if (data.hasOwnProperty('subscription'))
        obj.subscription = SubscriptionsSubscription.constructFromObject(data['subscription']);
    }
    return obj;
  }
}

/**
 * @member {module:model/SubscriptionsSubscription} subscription
 */
SubscriptionsBody.prototype.subscription = undefined;

